import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilderPage.vue?vue&type=template&id=29456166&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-meal-builder-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-meal-builder-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorMealBuilderPage.vue?vue&type=style&index=0&id=29456166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29456166",
  null
  
)

export default component.exports